import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import cliente1 from '../assets/clientes/detran_logo2.0.png';
import cliente2 from '../assets/clientes/Logo-Codemar.png';
import cliente3 from '../assets/clientes/Logo-Prefeitura-Horizontal-Branco-2-1.png';
import cliente4 from '../assets/clientes/LogoSite_PrefeituraSaquarema_800xProporcional.png';
import cliente5 from '../assets/clientes/macae.png';



export default function Clientes() {
  const logos = [cliente1, cliente2, cliente3, cliente4, cliente5];

  return (
    <section className="section clientes" id="clientes">
      <h2>Nossos Clientes</h2>

      <div className="clientes-swiper-wrapper">
        <Swiper
          modules={[Autoplay, Navigation, Pagination]}
          spaceBetween={25}
          slidesPerView={4}
          navigation
          pagination={{ clickable: true }}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          loop={true} // 🔥 garante que nunca fique vazio
          breakpoints={{
            320: { slidesPerView: 1 },
            480: { slidesPerView: 2 },
            768: { slidesPerView: 3 },
            1024: { slidesPerView: 4 },
          }}
        >
          {logos.map((logo, index) => (
            <SwiperSlide key={index}>
              <div className="cliente-logo-wrapper">
                <img
                  src={logo}
                  alt={`Cliente ${index + 1}`}
                  className="cliente-logo"
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}
